/* =========================================================
   PAS · header menu parents
   ---------------------------------------------------------
   Some top level menu items exist only to hold a dropdown, so
   their URL is "#". Clicking one used to do nothing at all:
   on the phone the menu just sat there, on the desktop it
   pushed a "#" onto the address bar.

   snippets/horizontal-menu.liquid marks those links with
   data-pas-menu-parent. Here:

     phone   ≤1024px   the tap drills into the submenu instead
     desktop ≥1025px   nothing happens — the dropdown already
                       opens on hover, and the item is not a
                       link to anywhere

   The theme's own "Redirect to link when click menu parent item"
   setting is left alone; this only ever touches items whose URL
   is a placeholder, so real parent links keep working.
   ========================================================= */
(function () {
  'use strict';

  var DESKTOP = 1025;

  function onDocumentClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var link = target.closest('a[data-pas-menu-parent]');
    if (!link) return;

    /* Never follow the placeholder URL. */
    event.preventDefault();

    if (window.innerWidth >= DESKTOP) return;

    /* Phone: open the submenu. The theme's open-children-toggle already
       knows how, so hand the tap over to it rather than copying the
       logic — that keeps the back button and the close button working. */
    var item = link.closest('menu-item');
    if (!item) return;

    var toggle = item.querySelector('open-children-toggle');
    if (toggle) toggle.click();
  }

  document.addEventListener('click', onDocumentClick, false);
})();
